import 'nprogress/nprogress.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/ReactToastify.min.css';
import './i18n';
import App from './App';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { LicenseManager } from 'ag-grid-enterprise';
import { ToastContainer } from 'react-toastify';
import { APP_CONFIG } from '@/utils/env';
import rootStore from './store';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { queryClient } from '@/utils/queryClient';
import { AGENT_SPECIAL_LIST } from './interfaces';

LicenseManager.setLicenseKey(APP_CONFIG.aggrid_license as string);

// Override page title from environment if provided
const configuredPageTitle = process.env.REACT_APP_PAGE_TITLE;
if (configuredPageTitle && typeof document !== 'undefined') {
  document.title = configuredPageTitle;
}

// Override favicon from environment if provided
const DEFAULT_FAVICON_PATH = AGENT_SPECIAL_LIST.includes(APP_CONFIG.agentSpecial || "") ? '/static/images/mix-logo-bellagio.svg' : '/static/images/mix-logo.svg';
const configuredFavicon = process.env.REACT_APP_FAVICON || DEFAULT_FAVICON_PATH;
if (configuredFavicon && typeof document !== 'undefined') {
  const faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
  if (faviconLink) {
    const isAbsolute = /^(https?:)?\/\//.test(configuredFavicon) || configuredFavicon.startsWith('data:');
    const base = process.env.PUBLIC_URL || '';
    const href = isAbsolute
      ? configuredFavicon
      : `${base}${configuredFavicon.startsWith('/') ? '' : '/'}${configuredFavicon}`;
    faviconLink.href = href;
  }
}

ReactDOM.render(
  <Provider store={rootStore}>
    <QueryClientProvider client={queryClient}>
      <SidebarProvider>
        <BrowserRouter>
          <App />
          <ToastContainer />
          <ReactQueryDevtools position="bottom-right" />
        </BrowserRouter>
      </SidebarProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root'),
);
